import { useDispatch, useSelector, useStore } from "react-redux";
import { saveTeam as saveTeamAction } from "./actions";

const useTeamsContext = () => {
	const dispatch = useDispatch();
	const store = useStore();

	const useHomeTeam = () => useSelector((state) => state.teams.homeTeam);

	const useAwayTeam = () => useSelector((state) => state.teams.awayTeam);

	const useTeamColor = (team) =>
		useSelector((state) => {
			const { homeTeam, awayTeam } = state.teams;
			if (team.id === homeTeam?.id) {
				return homeTeam.color;
			}
			if (team.id === awayTeam?.id) {
				return awayTeam.color;
			}
			return team.color;
		});

	const saveTeam = (team) => {
		const { game } = store.getState().game;
		saveTeamAction(team, game, dispatch);
	};

	const state = {
		homeTeam: useHomeTeam,
		awayTeam: useAwayTeam,
		teamColor: useTeamColor
	};

	return {
		state,
		saveTeam
	};
};

export { useTeamsContext };
